// import { fabric } from "fabric";
import { sprintf } from "sprintf-js";
import { NU_TO_PU, PU_TO_NU } from "../../../common/constants";
import { ZoomFitEnum } from "../../../common/enums";
import { calcRevH } from "../../../common/mapper/CoordinateTanslater";
import { makeNPageIdStr, PATH_THICKNESS_SCALE } from "../../../common/util";
import { PDFVIEW_ZOOM_MAX, PDFVIEW_ZOOM_MIN } from "../../RendererConstants";
import VirtualPen from "../../../neosmartpen/VirtualPen";
import Hammer from "hammerjs";
import { FabricCanvas, FabricLine, FabricPoint, FabricRect, FabricText } from "../../PseudoFabric";
import { PdfImageCanvas } from "../../PseudoFabric/PdfImageCanvas";
let instanceNum = 0;
/**
 * @enum {string}
 */
export const GRID_OBJECT_ID = "g";
const CROP_AREA_ID = "cr";
const GRID_TEXT_ID = "tt";
export default class RenderWorkerBase {
    get pageInfo() {
        return this._pageInfo;
    }
    set pageInfo(p) {
        // console.log(`pageInfo set <= ${makeNPageIdStr(p)}`);
        this._pageInfo = p;
    }
    get h() {
        return this._h;
    }
    set h(value) {
        this._h = value;
    }
    /**
     *
     * @param {RenderWorkerOption} options
     */
    constructor(options) {
        /** <canvas>내의 drawing canvas(fabric canvas)의 offset, 현재는 안 씀 - 2020/11/08*/
        this.offset = { x: 0, y: 0, zoom: 1 };
        /** FabricJs canvas */
        // canvasFb: fabric.Canvas = null;
        // canvasFbCompleted: fabric.Canvas = null;
        // canvasFbPdf: fabric.Canvas = null;
        this.canvasFb = null;
        this.canvasFbCompleted = null;
        this.canvasFbPdf = null;
        /** mouse drag & panning 을 위해 */
        this.pan = {
            isDragging: false,
            last_x: 0,
            last_y: 0,
        };
        this.crop = {
            isDragging: false,
            last_x: 0,
            last_y: 0,
            // rc: null as fabric.Rect,
            rc: null,
        };
        this.drawing = {
            isDragging: false,
            last_x: 0,
            last_y: 0,
        };
        // /** 종이 정보 */
        this.paperBase = {
            Xmin: 3.12,
            Ymin: 3.12,
        };
        /** animation timer */
        this.scrollAnimateTimer = null;
        this.zoomAnimateTimer = null;
        this.logCnt = 0;
        this.infoTexts = [];
        this._pinchStartingOffset = undefined;
        this._prevCenter = undefined;
        this.initHammerEvent = (divId) => {
            const c = document.getElementById(divId);
            this._mc = new Hammer.Manager(c);
            if (!this._opt.disableAnyMouseAction) {
                const pinch = new Hammer.Pinch();
                const pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 });
                const tab = new Hammer.Tap();
                // const rotate = new Hammer.Rotate();
                // pinch.recognizeWith(rotate);
                // add to the Manager
                this._mc.add([pinch, pan, tab]);
                this._mc.on("pinch pinchstart pinchend", this.onTouchPinch);
                this._mc.on("panstart panmove panend", this.onTouchDrag);
                this._mc.on("tap press", this.onTouchTapAndPress);
            }
        };
        this.setOption = (key, value) => {
            this._opt[key] = value;
        };
        /**
         * @protected
         */
        this.initFabricCanvas = () => {
            const size = this._opt.pageSize_pu;
            const dpr = 1;
            // console.log(`Fabric canvas inited: size(${size.width}, ${size.height})`);
            // this.canvasFbPdf = new fabric.Canvas(
            this.canvasFbPdf = new PdfImageCanvas(this._opt.canvasPdf, {
                backgroundColor: this._opt.bgColor ? this._opt.bgColor : "#fff",
                selection: false,
                controlsAboveOverlay: false,
                selectionLineWidth: 4,
                width: size.width * dpr,
                height: size.height * dpr,
            });
            // this.canvasFbCompleted = new fabric.Canvas(
            this.canvasFbCompleted = new FabricCanvas(this._opt.canvasCompleted, {
                backgroundColor: undefined,
                selection: false,
                controlsAboveOverlay: false,
                selectionLineWidth: 4,
                width: size.width * dpr,
                height: size.height * dpr,
            });
            // this.canvasFb = new fabric.Canvas(
            this.canvasFb = new FabricCanvas(this._opt.canvas, {
                backgroundColor: undefined,
                selection: false,
                controlsAboveOverlay: false,
                selectionLineWidth: 4,
                width: size.width * dpr,
                height: size.height * dpr,
            });
        };
        this.onCanvasPointerDown = (opt) => {
            // console.log("down", opt.e.changedTouches?.[0].identifier, opt.e.changedTouches);
            const opt2 = { e: opt };
            opt = opt2;
            if (!opt.e.changedTouches) {
                this.onCanvasMouseDown(opt);
            }
        };
        this.onCanvasPointerMove = (opt) => {
            // console.log("move", opt.e.changedTouches?.[0].identifier, opt.e.changedTouches);
            const opt2 = { e: opt };
            opt = opt2;
            if (!opt.e.changedTouches) {
                this.onCanvasMouseMove(opt);
            }
        };
        this.onCanvasPointerUp = (opt) => {
            // console.log("up", opt.e.changedTouches?.[0].identifier, opt.e.changedTouches);
            const opt2 = { e: opt };
            opt = opt2;
            if (!opt.e.changedTouches) {
                this.onCanvasMouseUp(opt);
            }
        };
        this.onCanvasPointerWheel = (opt) => {
            const opt2 = { e: opt };
            opt = opt2;
            if (!opt.e.changedTouches) {
                this.onCanvasMouseWheel(opt);
            }
        };
        this.getPageSize_pu = () => {
            const s = Object.assign({}, this._opt.pageSize_pu);
            // const { rotation } = this._opt;
            // console.log(`VIEW SIZE${callstackDepth()} getPageSize_pu ${this.logCnt++}: ${s.width}, ${s.height}`);
            return s;
        };
        this.drawInfoText = (sw = false) => {
            if (sw) {
                const canvasFb = this.canvasFb;
                const objects = canvasFb.getObjects();
                const texts = objects.filter(obj => obj.data === GRID_TEXT_ID);
                texts.forEach((obj) => {
                    this.canvasFb.remove(obj);
                });
                const msg = sprintf("instance:%d, zoom:%.2f, pageInfo:%s, viewSize:(%d,%d) pageSize:(%d,%d)\n", instanceNum, this.offset.zoom, makeNPageIdStr(this.pageInfo), Math.round(this._opt.viewSize.width), Math.round(this._opt.viewSize.height), Math.round(this._opt.pageSize_pu.width), Math.round(this._opt.pageSize_pu.height));
                this.infoTexts.unshift(msg);
                const len = this.infoTexts.length;
                for (let i = 0; i < 25 && i < len; i++) {
                    // const text = new fabric.Text(this.infoTexts[i],
                    const text = new FabricText(this.infoTexts[i], {
                        left: 10,
                        top: 10 + i * 20,
                        fill: "black",
                        fontSize: 12,
                        data: GRID_TEXT_ID
                    });
                    canvasFb.add(text);
                }
            }
            return;
        };
        this.setDrawGridOn = (sw) => {
            this._opt.showGrid = sw;
            if (sw) {
                this.drawPageLayout();
            }
            else {
                // 지우기
                if (this.canvasFb) {
                    const objects = this.canvasFb.getObjects();
                    const strokes = objects.filter(obj => obj.data === GRID_OBJECT_ID);
                    strokes.forEach((obj) => {
                        this.canvasFb.remove(obj);
                    });
                }
            }
        };
        this.drawDummyPageLayout = () => {
            const canvasFb = this.canvasFb;
            // 지우기
            if (this.canvasFb) {
                const objects = this.canvasFb.getObjects();
                const strokes = objects.filter(obj => obj.data === GRID_OBJECT_ID);
                strokes.forEach((obj) => {
                    this.canvasFb.remove(obj);
                });
            }
            // 그리기
            const size = this.getPageSize_pu();
            // console.log(`VIEW SIZE${callstackDepth()} DrawPageLayout: ${size.width}, ${size.height} = ${size.width / size.height}`);
            const ratio = 1;
            const msg = `\n` +
                `/** EXAMPLE CODE */\n` +
                `\n` +
                `const msi = MappingStorage.getInstance();\n` +
                `const theBase = msi.makeTemporaryAssociateMapItem({\n` +
                `  n_paper: undefined, \n` +
                `  pdf: undefined, \n` +
                `  numBlankPages: 1,\n` +
                `  background_image_url_rule: null\n` +
                `});\n` +
                `\n` +
                `const blankPageInfo = theBase.basePageInfo;\n` +
                `const is = InkStorage.getInstance();\n` +
                `is.addDummyPage(blankPageInfo);\n` +
                `\n` +
                `\n` +
                `/** in render(), add "pageInfo" property of MixedPageView */\n` +
                `<MixedPageView ... .pageInfo={blankPageInfo} />;\n`;
            // const rect = new fabric.Rect({
            const rect = new FabricRect({
                width: size.width * ratio - 5,
                height: size.height * ratio - 5,
                strokeWidth: 5,
                stroke: 'rgba(0,0,0,1)',
                fill: 'rgb(100,100,200, 0.1)',
                left: size.width * (1 - ratio) * 0.5,
                top: size.height * (1 - ratio) * 0.5,
                selectable: false,
                data: GRID_OBJECT_ID,
                name: 'page_layout'
            });
            canvasFb.add(rect);
            this.drawInfoText();
            // const text = new fabric.Text('Page not assigned. please assign a page', {
            const text = new FabricText('Page not assigned. please assign a page', {
                left: 10,
                top: 10,
                // stroke: 'rgba(0,0,0,1)',
                fill: 'rgb(255,46,0,1)',
                fontSize: 24,
                selectable: false,
                data: GRID_OBJECT_ID,
                name: 'page_layout'
            });
            canvasFb.add(text);
            const strArr = msg.split("\n");
            strArr.forEach((s, i) => {
                // const t = new fabric.Text(s, {
                const t = new FabricText(s, {
                    left: 10,
                    top: 40 + i * 16,
                    // stroke: 'rgba(0,0,0,1)',
                    fill: 'rgb(0,0,0,1)',
                    fontSize: 13,
                    fontWeight: 400,
                    fontFamily: "lucida console",
                    selectable: false,
                    data: GRID_OBJECT_ID,
                    name: 'page_layout'
                });
                canvasFb.add(t);
            });
        };
        this.drawPageLayout = () => {
            // console.log(`VIEW SIZE${callstackDepth()} DrawPageLayout`);
            if (!this._opt.showGrid)
                return;
            if (!this.pageInfo) {
                this.drawDummyPageLayout();
                return;
            }
            const canvasFb = this.canvasFb;
            // 지우기
            if (this.canvasFb) {
                const objects = this.canvasFb.getObjects();
                const strokes = objects.filter(obj => obj.data === GRID_OBJECT_ID);
                strokes.forEach((obj) => {
                    this.canvasFb.remove(obj);
                });
            }
            // 그리기
            const size = this.getPageSize_pu();
            // console.log(`VIEW SIZE${callstackDepth()} DrawPageLayout: ${size.width}, ${size.height} = ${size.width / size.height}`);
            const ratio = 1;
            // const rect = new fabric.Rect({
            const rect = new FabricRect({
                width: size.width * ratio - 5,
                height: size.height * ratio - 5,
                strokeWidth: 5,
                stroke: 'rgba(0,0,0,1)',
                fill: 'rgb(100,100,200, 0.1)',
                left: size.width * (1 - ratio) * 0.5,
                top: size.height * (1 - ratio) * 0.5,
                selectable: false,
                data: GRID_OBJECT_ID,
                name: 'page_layout'
            });
            canvasFb.add(rect);
            this.drawInfoText();
            let sw = true;
            for (let x = 0; x < size.width; x += size.width / 4) {
                let color = "rgba(0,0,0,0.3)";
                if (sw)
                    color = "rgba(0,0,0,0.8)";
                sw = !sw;
                // const line = new fabric.Line([x, 0, x, size.height], {
                const line = new FabricLine([x, 0, x, size.height], {
                    strokeWidth: 0.5,
                    stroke: color,
                    hasControls: false,
                    hasBorders: false,
                    lockMovementX: true,
                    lockMovementY: true,
                    data: GRID_OBJECT_ID,
                    name: 'page_layout'
                });
                canvasFb.add(line);
            }
            sw = true;
            for (let y = 0; y < size.height; y += size.height / 4) {
                let color = "rgba(0,0,0,0.3)";
                if (sw)
                    color = "rgba(0,0,0,0.8)";
                sw = !sw;
                // const line = new fabric.Line([0, y, size.width, y], {
                const line = new FabricLine([0, y, size.width, y], {
                    strokeWidth: 0.5,
                    stroke: color,
                    hasControls: false,
                    hasBorders: false,
                    lockMovementX: true,
                    lockMovementY: true,
                    data: GRID_OBJECT_ID,
                    name: 'page_layout'
                });
                canvasFb.add(line);
            }
        };
        /**
         * enable/disable mouse drag panning and zoom in/out
         * default: true
         *
         * @public
         * @param {boolean} sw
         */
        this.disableMouseAction = (sw) => {
            // if (this._opt.mouseAction !== sw) {
            const canvasFb = this.canvasFb;
            if (sw) {
                this.onCanvasMouseUp();
                canvasFb.off('mouse:down', this.onCanvasPointerDown);
                canvasFb.off('mouse:move', this.onCanvasPointerMove);
                canvasFb.off('mouse:up', this.onCanvasPointerUp);
                canvasFb.off('mouse:wheel', this.onCanvasPointerWheel);
                this._mc.off("pinch pinchstart pinchend", this.onTouchPinch);
                this._mc.off("panstart panmove panend", this.onTouchDrag);
            }
            else {
                canvasFb.on('mouse:down', this.onCanvasPointerDown);
                canvasFb.on('mouse:move', this.onCanvasPointerMove);
                canvasFb.on('mouse:up', this.onCanvasPointerUp);
                canvasFb.on('mouse:wheel', this.onCanvasPointerWheel);
                this._mc.on("pinch pinchstart pinchend", this.onTouchPinch);
                this._mc.on("panstart panmove panend", this.onTouchDrag);
            }
            // }
            this._opt.disableAnyMouseAction = sw;
        };
        this.setCropMode = (on) => {
            this._opt.isCropMode = on;
            this.crop.isDragging = false;
            this.pan.isDragging = false;
        };
        /**
         * enable/disable auto set focus at current stroke point
         * default: true
         *
         * @public
         * @param {boolean} sw
         */
        this.enableAutoFocus = (sw) => {
            this._opt.disableAutoFocus = !sw;
        };
        /**
         * @protected
         * @param {Object} opt
         */
        this.onCanvasMouseDown = (opt, eventSrc = "mouse") => {
            const evt = opt.e;
            const isMetaKeyDown = (evt.ctrlKey === true || evt.altKey === true);
            if (!this._opt.disablePanZoom && isMetaKeyDown) {
                // pan 이면
                const canvasFb = this.canvasFb;
                const evt = opt.e;
                this.pan.isDragging = true;
                this.pan.last_x = evt.clientX;
                this.pan.last_y = evt.clientY;
                console.log(`onCanvasMouseDown ${this.pan.last_x}, ${this.pan.last_y}`);
                canvasFb.selection = false;
            }
            if (this._opt.isCropMode) {
                // crop mode 이면
                const p = this.canvasFb.getPointer(opt.e);
                this.crop.isDragging = true;
                this.crop.last_x = p.x;
                this.crop.last_y = p.y;
                // const rect = new fabric.Rect({
                const rect = new FabricRect({
                    width: 0,
                    height: 0,
                    strokeWidth: 1,
                    stroke: 'rgba(0,0,0,1)',
                    fill: 'rgb(100,200,100, 0.1)',
                    left: p.x,
                    top: p.y,
                    selectable: false,
                    data: CROP_AREA_ID,
                    name: CROP_AREA_ID
                });
                this.canvasFb.add(rect);
                this.crop.rc = rect;
            }
            else if (!this._opt.disableVirtualPen && !isMetaKeyDown) {
                // mouse drawing 이면, kitty, 2021/03/23
                const p = this.canvasFb.getPointer(opt.e);
                // 그리기 시작
                // 2021/01/12 PointerEvent도 처리할 수 있도록 추가해야 함
                const drawAvailable = this.onTouchStrokePenDown(evt);
                this.drawing.isDragging = drawAvailable;
                this.drawing.last_x = p.x;
                this.drawing.last_y = p.y;
                // 아래를 추가할 것, 2021/01/12, kitty
                // this.onTouchStrokePenMove(evt);
            }
            // callback이 있으면 callback으로 돌려준다
            if (this._opt.onMouseDown) {
                const e = opt.e;
                const p = this.canvasFb.getPointer(opt.e);
                e["sobp"] = this.pageInfo;
                e["pdfX"] = p.x;
                e["pdfY"] = p.y;
                this._opt.onMouseDown(e);
            }
            // evt.preventDefault();
        };
        /**
         * 손으로 쓰는 글씨에 대응
         * @param ev
         */
        this.onTouchDrag = (ev) => {
            // 마우스는 처리하지 않는다
            if (ev.pointerType === "mouse")
                return;
            const srcEvent = ev.srcEvent;
            switch (ev.type) {
                case "panstart": {
                    const e = { e: srcEvent };
                    // touch 가 아니고 mouse인 이유는 부드러운 스크롤을 위해
                    this.onCanvasMouseDown(e, "mouse");
                    break;
                }
                case "panmove": {
                    const e = { e: srcEvent };
                    // touch 가 아니고 mouse인 이유는 부드러운 스크롤을 위해
                    this.onCanvasMouseMove(e, "mouse");
                    break;
                }
                case "panend": {
                    const e = { e: srcEvent };
                    // touch 가 아니고 mouse인 이유는 부드러운 스크롤을 위해
                    this.onCanvasMouseUp(e, "mouse");
                    break;
                }
            }
        };
        this.onTouchTapAndPress = (ev) => {
            const srcEvent = ev.srcEvent;
            const p = this.canvasFb.getPointer(srcEvent);
            switch (ev.type) {
                case "tap": {
                    if (this._opt.onTouchTap) {
                        srcEvent["sobp"] = this.pageInfo;
                        srcEvent["pdfX"] = p.x;
                        srcEvent["pdfY"] = p.y;
                        this._opt.onTouchTap(srcEvent);
                    }
                    break;
                }
                case "press": {
                    break;
                }
            }
            if (this._opt.onMouseMove) {
                if (this._opt.onTouchPress) {
                    srcEvent["sobp"] = this.pageInfo;
                    srcEvent["pdfX"] = p.x;
                    srcEvent["pdfY"] = p.y;
                    this._opt.onTouchPress(srcEvent);
                }
            }
        };
        /**
         * @protected
         * @param {Object} opt
         */
        this.onCanvasMouseMove = (opt, eventSrc = "mouse") => {
            // const canvasFb = this.canvasFb;
            const evt = opt.e;
            const isMetaKeyDown = (evt.ctrlKey === true || evt.altKey === true);
            if (!this._opt.disablePanZoom && isMetaKeyDown) {
                if (this.pan.isDragging) {
                    this._opt.onViewPositionControlledBy(eventSrc);
                    this.scrollBoundaryCheck({
                        x: this.offset.x + evt.clientX - this.pan.last_x,
                        y: this.offset.y + evt.clientY - this.pan.last_y,
                        zoom: this.offset.zoom
                    });
                    this.pan.last_x = evt.clientX;
                    this.pan.last_y = evt.clientY;
                }
            }
            if (this._opt.isCropMode && this.crop.isDragging) {
                // crop mode 이면
                const p = this.canvasFb.getPointer(opt.e);
                const { last_x, last_y, rc } = this.crop;
                const left = Math.min(last_x, p.x);
                const top = Math.min(last_y, p.y);
                const dx = Math.abs(p.x - last_x);
                const dy = Math.abs(p.y - last_y);
                rc.set("width", dx).set("left", left);
                rc.set("height", dy).set("top", top);
                rc.setCoords();
                this.canvasFb.requestRenderAll();
            }
            else if (!this._opt.disableVirtualPen && !isMetaKeyDown) {
                // 그리기 중간
                // 2021/01/12 PointerEvent도 처리할 수 있도록 추가해야 함
                if (this.drawing.isDragging) {
                    // kitty, 2021/03/23
                    const p = this.canvasFb.getPointer(opt.e);
                    // const dx = p.x - this.drawing.last_x;
                    // const dy = p.y - this.drawing.last_y;
                    // const distance2 = Math.sqrt(Math.sqrt(dx * dx + dy * dy));
                    // const distance = Math.max(1, distance2);
                    // const force = 800 / distance;
                    // this.drawing.last_x = evt.clientX;
                    // this.drawing.last_y = evt.clientY;
                    this.drawing.last_x = p.x;
                    this.drawing.last_y = p.y;
                    this.onTouchStrokePenMove(evt, p, VirtualPen.virtualPenMaxPressure);
                }
            }
            // callback이 있으면 callback으로 돌려준다
            if (this._opt.onMouseMove) {
                const e = opt.e;
                const p = this.canvasFb.getPointer(opt.e);
                e["sobp"] = this.pageInfo;
                e["pdfX"] = p.x;
                e["pdfY"] = p.y;
                this._opt.onMouseMove(e);
            }
            // evt.preventDefault();
        };
        this.reportCanvasChanged = (offset) => {
            // const { x: offsetX, y: offsetY, zoom } = this.offset;
            // console.log(`reportCanvasChanged ${offset.offsetX}, ${offset.offsetY}`)
            const c = this.canvasFbPdf || this.canvasFbCompleted;
            if (!c)
                return;
            const { width, height } = c;
            this._opt.onCanvasPositionChanged(Object.assign({}, offset));
        };
        /**
         * @protected
         * @param {Object} opt
         */
        this.onCanvasMouseUp = (opt = undefined, eventSrc = "mouse") => {
            const evt = opt.e;
            if (this.pan.isDragging) {
                const canvasFb = this.canvasFb;
                canvasFb.selection = false;
                this.pan.isDragging = false;
            }
            if (this._opt.isCropMode && this.crop.isDragging) {
                // crop mode 이면
                this.crop.isDragging = false;
                const p = this.canvasFb.getPointer(opt.e);
                const { last_x, last_y } = this.crop;
                // const dx = p.x - last_x;
                // const dy = p.y - last_y;
                this.canvasFb.remove(this.crop.rc);
                this.canvasFb.requestRenderAll();
                // callback 함수가 있으면 돌려준다
                if (this._opt.onCropRangeChagned) {
                    let left = Math.min(last_x, p.x);
                    let top = Math.min(last_y, p.y);
                    if (left < 0)
                        left = 0;
                    if (top < 0)
                        top = 0;
                    let right = Math.max(last_x, p.x);
                    let bottom = Math.max(last_y, p.y);
                    const { width, height } = this.getPageSize_pu();
                    if (right > width)
                        right = width;
                    if (bottom > height)
                        bottom = height;
                    const rc = {
                        unit: "pu",
                        x: left,
                        y: top,
                        width: right - left,
                        height: bottom - top,
                    };
                    this._opt.onCropRangeChagned({ rect: rc, pageInfo: Object.assign({}, this.pageInfo) });
                    // this.zoomToRect(rc);
                }
            }
            else if (!this._opt.disableVirtualPen && this.drawing.isDragging) {
                // 그리기 끝
                // 2021/01/12 PointerEvent도 처리할 수 있도록 추가해야 함
                this.drawing.isDragging = false;
                this.onTouchStrokePenUp(evt);
            }
            // callback이 있으면 callback으로 돌려준다
            if (this._opt.onMouseUp) {
                const e = opt.e;
                const p = this.canvasFb.getPointer(opt.e);
                e["sobp"] = this.pageInfo;
                e["pdfX"] = p.x;
                e["pdfY"] = p.y;
                this._opt.onMouseUp(e);
            }
            // evt.preventDefault();
        };
        /**
         * @protected
         * @param {Object} opt
         */
        this.onCanvasMouseWheel = (opt, syntheticEvent = false) => {
            if (this._opt.setViewFitFn) {
                this._opt.setViewFitFn(ZoomFitEnum.FREE);
            }
            this._opt.viewFit = ZoomFitEnum.FREE;
            const evt = opt.e;
            // if (!this._opt.disablePanZoom && ) {
            // const isMetaKeyDown = (evt.ctrlKey === true || evt.altKey === true);
            const isMetaKeyDown = (evt.altKey === true);
            if (!this._opt.disablePanZoom && isMetaKeyDown) {
                this._opt.onViewPositionControlledBy("mouse");
                const delta = opt.e.deltaY;
                let zoom = this.offset.zoom;
                zoom *= Math.pow(0.9985, delta);
                if (zoom > PDFVIEW_ZOOM_MAX)
                    zoom = PDFVIEW_ZOOM_MAX;
                if (zoom < PDFVIEW_ZOOM_MIN)
                    zoom = PDFVIEW_ZOOM_MIN;
                // MixedPageView에서 들어온 마우스 이벤트라면
                // let pt = new fabric.Point(evt.offsetX, evt.offsetY);
                let pt = new FabricPoint(evt.offsetX, evt.offsetY);
                if (evt.offsetX === undefined || evt.offsetY === undefined) {
                    // pt = new fabric.Point(evt.clientX - this.offset.x, evt.clientY - this.offset.y);
                    pt = new FabricPoint(evt.clientX - this.offset.x, evt.clientY - this.offset.y);
                }
                this.zoomToPoint(pt, zoom);
                // evt.preventDefault();
            }
            // callback이 있으면 callback으로 돌려준다
            if (this._opt.onMouseWheel && (!syntheticEvent)) {
                const e = opt.e;
                const p = this.canvasFb.getPointer(opt.e);
                e["sobp"] = this.pageInfo;
                e["pdfX"] = p.x;
                e["pdfY"] = p.y;
                this._opt.onMouseWheel(e);
            }
        };
        /**
         * Pinch to Zoom에 대응
         * @param ev
         */
        this.onTouchPinch = (ev) => {
            if (this._opt.setViewFitFn) {
                this._opt.setViewFitFn(ZoomFitEnum.FREE);
            }
            if (!this._opt.disablePanZoom) {
                this._opt.onViewPositionControlledBy("touch");
                const e = ev;
                const p0 = this.canvasFb.getPointer(ev.pointers[0]);
                const p1 = this.canvasFb.getPointer(ev.pointers[1]);
                const c = { x: (p0.x + p1.x) / 2, y: (p0.y + p1.y) / 2 };
                if (e.type === "pinchstart") {
                    this._pinchStartingOffset = Object.assign({}, this.offset);
                    this._prevCenter = Object.assign({}, ev.center);
                }
                const dx = ev.center.x - this._prevCenter.x;
                const dy = ev.center.y - this._prevCenter.y;
                const x = this.offset.x + dx;
                const y = this.offset.y + dy;
                const z = this._pinchStartingOffset.zoom * e.scale;
                console.log(e.type, dx, dy, x, y, z, e.center);
                this.zoomToPoint(c, z);
                this.scrollBoundaryCheck({ x, y, zoom: z });
                this._prevCenter = Object.assign({}, ev.center);
            }
        };
        this.scrollBoundaryCheck = (pos) => {
            // http://fabricjs.com/fabric-intro-part-5#pan_zoom
            if (isNaN(pos.x) || isNaN(pos.y)) {
                console.log(`offset: NaN want move to (${pos.x}, ${pos.y})`);
                return false;
            }
            // console.log(`offset: want move to (${pos.x}, ${pos.y})`)
            const zoom = pos.zoom;
            let offsetX = pos.x;
            let offsetY = pos.y;
            const pageSize = {
                width: this._opt.pageSize_pu.width * zoom,
                height: this._opt.pageSize_pu.height * zoom
            };
            // let shouldReset = false;
            if (pageSize.width <= this._opt.viewSize.width) {
                offsetX = Math.round((this._opt.viewSize.width - pageSize.width) / 2);
                // shouldReset = true;
            }
            else {
                if (offsetX > 0) {
                    offsetX = 0;
                    // shouldReset = true;
                }
                else if (offsetX + pageSize.width < this._opt.viewSize.width) {
                    offsetX = this._opt.viewSize.width - pageSize.width;
                    // shouldReset = true;
                }
            }
            if (pageSize.height <= this._opt.viewSize.height) {
                offsetY = Math.round((this._opt.viewSize.height - pageSize.height) / 2);
                // shouldReset = true;
            }
            else {
                if (offsetY > 0) {
                    offsetY = 0;
                    // shouldReset = true;
                }
                else if (offsetY + pageSize.height < this._opt.viewSize.height) {
                    offsetY = this._opt.viewSize.height - pageSize.height;
                    // shouldReset = true;
                }
            }
            // if (shouldReset) {
            //   if (offsetX !== this.offset.x || offsetY !== this.offset.y) {
            //     console.log(`prev offset (${this.offset.x}, ${this.offset.y}) => (${offsetX}, ${offsetY})`)
            //     // this.offset.x = offsetX;
            //     // this.offset.y = offsetY;
            //     this.reportCanvasChanged();
            //   }
            // }
            const shouldReport = (offsetX !== this.offset.x || offsetY !== this.offset.y);
            if (shouldReport) {
                // console.log(`prev offset (${this.offset.x}, ${this.offset.y}) => (${offsetX}, ${offsetY})`)
                this.reportCanvasChanged({ offsetX, offsetY, zoom });
                this.offset = { x: offsetX, y: offsetY, zoom };
            }
            return shouldReport;
        };
        // setCanvasZoom = (zoom: number, opt: any) => {
        //   const canvasFb = this.canvasFb;
        //   if (zoom > PDFVIEW_ZOOM_MAX) zoom = PDFVIEW_ZOOM_MAX;
        //   if (zoom < PDFVIEW_ZOOM_MIN) zoom = PDFVIEW_ZOOM_MIN;
        //   const evt: MouseEvent = opt.e;
        //   const pt = new fabric.Point(evt.offsetX, evt.offsetY);
        //   if (opt) {
        //     console.log(`setCanvasZoom: ${zoom}`);
        //     this.zoomToPoint(pt, zoom);
        //   }
        //   else {
        //     // canvasFb.setZoom(zoom);
        //     this.zoomToPoint(null, zoom);
        //   }
        //   // opt.e.preventDefault();
        //   // opt.e.stopPropagation();
        // }
        /**
         * focus and fit to Rect given
         *
         * @param {IRectDpi} rc
         * @memberof RenderWorkerBase
         */
        this.zoomToRect = (rc) => {
            const center = { x: Math.round(rc.x + rc.width / 2), y: Math.round(rc.y + rc.height / 2) };
            const szCanvas = Object.assign({}, this._opt.viewSize);
            szCanvas.width -= this._opt.fitMargin;
            szCanvas.height -= this._opt.fitMargin;
            // const rect = new fabric.Rect({
            //   width: 8,
            //   height: 8,
            //   strokeWidth: 1,
            //   fill: 'rgb(255,0,0, 1)',
            //   left: center.x - 4,
            //   top: center.y - 4,
            //   selectable: false,
            //   data: CROP_AREA_ID,
            //   name: CROP_AREA_ID
            // });
            // this.canvasFb.add(rect);
            const scale_x = szCanvas.width / rc.width;
            const scale_y = szCanvas.height / rc.height;
            let z = Math.min(scale_x, scale_y);
            if (z > PDFVIEW_ZOOM_MAX)
                z = PDFVIEW_ZOOM_MAX;
            this.zoomCanvas(z);
            // const crop_zw = rc.width * z;
            // const crop_zh = rc.height * z;
            const view_center = { x: this._opt.viewSize.width / 2, y: this._opt.viewSize.height / 2 };
            const offsetX = view_center.x - center.x * z;
            const offsetY = view_center.y - center.y * z;
            if (this.reportCanvasChanged) {
                this.reportCanvasChanged({ offsetX, offsetY, zoom: z });
            }
            this.offset = { x: offsetX, y: offsetY, zoom: z };
        };
        this.zoomCanvas = (z, force) => {
            var _a, _b;
            const zw = Math.round(this._opt.pageSize_pu.width * z);
            const zh = Math.round(this._opt.pageSize_pu.height * z);
            if (this.offset.zoom !== z || force) {
                this.offset.zoom = z;
                // zw = Math.round(this._opt.pageSize_pu.width * z);
                // zh = Math.round(this._opt.pageSize_pu.height * z);
                // this.canvasFb.setZoom(z);
                // this.canvasFb.setWidth(zw);
                // this.canvasFb.setHeight(zh);
                this.canvasFb.setSize(zw, zh);
                this.canvasFb.setZoom(z);
                this.canvasFb.requestRenderAll();
                // this.canvasFbCompleted.setZoom(z);
                // this.canvasFbCompleted.setWidth(zw);
                // this.canvasFbCompleted.setHeight(zh);
                this.canvasFbCompleted.setSize(zw, zh);
                this.canvasFbCompleted.setZoom(z);
                this.canvasFbCompleted.requestRenderAll();
                if (this.canvasFbPdf) {
                    // this.canvasFbPdf.setZoom(z);
                    // this.canvasFbPdf.setWidth(zw);
                    // this.canvasFbPdf.setHeight(zh);
                    this.canvasFbPdf.setSize(zw, zh);
                    this.canvasFbPdf.setZoom(z);
                    this.canvasFbPdf.requestRenderAll();
                }
                this.onZoomChanged(z);
            }
            (_b = (_a = this._opt).onSizeChanged) === null || _b === void 0 ? void 0 : _b.call(_a, { width: zw, height: zh });
        };
        this.zoomToPoint = (pt, zoom, animate = true) => {
            if (zoom > PDFVIEW_ZOOM_MAX)
                zoom = PDFVIEW_ZOOM_MAX;
            // const z1 = this.calcScaleFactor(this._opt.viewFit, zoom);
            const z1 = zoom;
            let x1 = this.offset.x;
            let y1 = this.offset.y;
            if (pt) {
                const z0 = this.offset.zoom;
                const x0 = this.offset.x;
                const y0 = this.offset.y;
                x1 = pt.x * (z0 - z1) / z0 + x0;
                y1 = pt.y * (z0 - z1) / z0 + y0;
            }
            this.zoomCanvas(zoom);
            this.scrollBoundaryCheck({ x: x1, y: y1, zoom });
        };
        /**
         * @protected
         * @param {{x:number, y:number, f?:number}} ncodeXY
         */
        this.ncodeToPdfXy_default = (ncodeXY) => {
            const { x, y, f } = ncodeXY;
            const { Xmin, Ymin } = this.paperBase;
            const px = (x - Xmin) * NU_TO_PU;
            const py = (y - Ymin) * NU_TO_PU;
            return { x: px, y: py, f };
        };
        this.pdfToNcodeXy_default = (ncodeXY) => {
            const { x, y, f } = ncodeXY;
            const { Xmin, Ymin } = this.paperBase;
            const nx = x * PU_TO_NU + Xmin;
            const ny = y * PU_TO_NU + Ymin;
            return { x: nx, y: ny, f };
        };
        this.ncodeToPdfXy_homography = (ncodeXY) => {
            const { x, y } = ncodeXY;
            const { a, b, c, d, e, f, g, h } = this.h;
            const nominator = g * x + h * y + 1;
            const px = (a * x + b * y + c) / nominator;
            const py = (d * x + e * y + f) / nominator;
            return { x: px, y: py, f: ncodeXY.f };
        };
        this.pdfToNcodeXy_homography = (ncodeXY) => {
            const { x, y } = ncodeXY;
            const { a, b, c, d, e, f, g, h } = this.h_rev;
            const nominator = g * x + h * y + 1;
            const px = (a * x + b * y + c) / nominator;
            const py = (d * x + e * y + f) / nominator;
            return { x: px, y: py, f: ncodeXY.f };
        };
        /**
         * @protected
         * @param {{x:number, y:number, f?:number}} ncodeXY
         */
        this.ncodeToPdfXy = (ncodeXY) => {
            const ret = this.funcNcodeToPdfXy(ncodeXY);
            const { x, y, f } = ret;
            return { x: x * PATH_THICKNESS_SCALE, y: y * PATH_THICKNESS_SCALE, f };
        };
        this.pdfToNcodeXy = (pdfXY) => {
            const ret = this.funcPdfToNcodeXy(pdfXY);
            const { x, y, f } = ret;
            return { x: x * PATH_THICKNESS_SCALE, y: y * PATH_THICKNESS_SCALE, f };
        };
        /**
         * @protected
         * @param {{x:number, y:number}} pdfXY
         */
        this.pdfToScreenXy = (pdfXY) => {
            const { x, y } = pdfXY;
            // const canvasFb = this.canvasFb;
            // const vpt = canvasFb.viewportTransform;
            const zoom = this.offset.zoom;
            const offset_x = this.offset.x;
            const offset_y = this.offset.y;
            const sx = x * zoom + offset_x;
            const sy = y * zoom + offset_y;
            return { x: sx, y: sy };
        };
        this.layerToPdfXy = (layerXY) => {
            const { x, y } = layerXY;
            const zoom = this.offset.zoom;
            const px = x / zoom;
            const py = y / zoom;
            return { x: px, y: py };
            // return { x: offset_x, y: offset_y };
        };
        this.screenToPdfXy = (screenXY) => {
            const { x, y } = screenXY;
            // const canvasFb = this.canvasFb;
            // const vpt = canvasFb.viewportTransform;
            const zoom = this.offset.zoom;
            const offset_x = this.offset.x;
            const offset_y = this.offset.y;
            const px = (x - offset_x) / zoom;
            const py = (y - offset_y) / zoom;
            return { x: px, y: py };
        };
        /**
         *
         * @param mode
         * @param szPaper
         * @param currScale
         */
        this.calcScaleFactor = (mode, currScale) => {
            const szPaper = this._opt.pageSize_pu;
            if (!szPaper.width)
                return currScale;
            const szCanvas = Object.assign({}, this._opt.viewSize);
            if (szCanvas.width === 0 && szCanvas.height === 0)
                return currScale;
            szCanvas.width -= this._opt.fitMargin;
            szCanvas.height -= this._opt.fitMargin;
            let scale = 1;
            switch (mode) {
                case ZoomFitEnum.WIDTH:
                    scale = szCanvas.width / szPaper.width;
                    break;
                case ZoomFitEnum.HEIGHT:
                    scale = szCanvas.height / szPaper.height;
                    break;
                case ZoomFitEnum.FULL:
                    scale = Math.min(szCanvas.width / szPaper.width, szCanvas.height / szPaper.height);
                    break;
                case ZoomFitEnum.ACTUAL:
                    scale = 1;
                    break;
                default:
                    scale = currScale;
                    break;
            }
            return scale;
        };
        /**
         * @protected
         * @param {{x:number, y:number}} dot
         */
        this.focusToDot = (dot) => {
            if (this._opt.disableAutoFocus)
                return;
            const margin_to_go_ratio = 0.25;
            const canvas_xy = this.funcNcodeToPdfXy(dot);
            const screen_xy = this.pdfToScreenXy(canvas_xy);
            let dx = 0, dy = 0;
            let shouldScroll = false;
            const offset_x = this.offset.x;
            const offset_y = this.offset.y;
            if (screen_xy.x < 0) {
                // scroll to left
                const target = this._opt.viewSize.width * margin_to_go_ratio;
                dx = target - screen_xy.x;
                shouldScroll = true;
            }
            if (screen_xy.y < 0) {
                // scroll to top
                const target = this._opt.viewSize.height * margin_to_go_ratio;
                dy = target - screen_xy.y;
                shouldScroll = true;
            }
            if (screen_xy.x > this._opt.viewSize.width) {
                // scroll to right
                const target = this._opt.viewSize.width * (1 - margin_to_go_ratio);
                dx = target - screen_xy.x;
                shouldScroll = true;
            }
            if (screen_xy.y > this._opt.viewSize.height) {
                // scroll to bottom
                const target = this._opt.viewSize.height * (1 - margin_to_go_ratio);
                dy = target - screen_xy.y;
                shouldScroll = true;
            }
            if (shouldScroll) {
                const new_offset_x = offset_x + dx;
                const new_offset_y = offset_y + dy;
                this.scrollCanvasToPoint({ x: new_offset_x, y: new_offset_y });
            }
        };
        /**
         *
         * @param {{x:number, y:number}} point
         * @param {boolean} animate
         */
        this.scrollCanvasToPoint = (point) => {
            const canvasFb = this.canvasFb;
            this.scrollBoundaryCheck({ x: point.x, y: point.y, zoom: this.offset.zoom });
            canvasFb.requestRenderAll();
            canvasFb.setViewportTransform(canvasFb.viewportTransform);
            this.canvasFbCompleted.requestRenderAll();
            this.canvasFbCompleted.setViewportTransform(canvasFb.viewportTransform);
            this.canvasFbPdf.requestRenderAll();
            this.canvasFbPdf.setViewportTransform(canvasFb.viewportTransform);
        };
        this.setRotation = (rotation) => {
            console.log(`RenderWorkerBase: setRotation to ${rotation}`);
            this._opt.rotation = rotation;
        };
        this.setTransformParameters = (h) => {
            this.h = Object.assign({}, h);
            const h_rev = calcRevH(h);
            this.h_rev = Object.assign({}, h_rev);
            if (h) {
                this.funcNcodeToPdfXy = this.ncodeToPdfXy_homography;
                this.funcPdfToNcodeXy = this.pdfToNcodeXy_homography;
            }
            else {
                this.funcNcodeToPdfXy = this.ncodeToPdfXy_default;
                this.funcPdfToNcodeXy = this.pdfToNcodeXy_default;
            }
            return this.h_rev;
        };
        this.removeObjectsInCanvas = (c) => {
            if (!c)
                return;
            const objects = c.getObjects();
            objects.forEach((obj) => {
                c.remove(obj);
            });
        };
        instanceNum++;
        this.name = "RenderWorkerBase";
        this.funcNcodeToPdfXy = this.ncodeToPdfXy_default;
        if (typeof options.canvasId !== "string") {
            throw new Error("canvasId should be a string");
        }
        this._opt = Object.assign({}, options);
        this.canvasFb = null;
        this.initFabricCanvas();
        this.initHammerEvent(this._opt.divId);
        if (!this._opt.disableAnyMouseAction) {
            const canvasFb = this.canvasFb;
            canvasFb.on('mouse:down', this.onCanvasPointerDown);
            canvasFb.on('mouse:move', this.onCanvasPointerMove);
            canvasFb.on('mouse:up', this.onCanvasPointerUp);
            canvasFb.on('mouse:wheel', this.onCanvasPointerWheel);
            // this._mc.on("pinch pinchstart pinchend", this.onTouchPinch);
            // this._mc.on("panstart panmove panend", this.onTouchDrag);
        }
    }
    prepareUnmount() {
        var _a, _b, _c;
        this._mc.off("pinch pinchstart pinchend", this.onTouchPinch);
        this._mc.off("panstart panmove panend", this.onTouchDrag);
        this._mc.off("tap press", this.onTouchTapAndPress);
        const canvasFb = this.canvasFb;
        canvasFb.off('mouse:down', this.onCanvasPointerDown);
        canvasFb.off('mouse:move', this.onCanvasPointerMove);
        canvasFb.off('mouse:up', this.onCanvasPointerUp);
        canvasFb.off('mouse:wheel', this.onCanvasPointerWheel);
        this._opt.canvas = null;
        this._opt.canvasPdf = null;
        this._opt.canvasCompleted = null;
        this.removeObjectsInCanvas(this.canvasFb);
        // this.removeObjectsInCanvas(this.canvasFbPdf);
        this.removeObjectsInCanvas(this.canvasFbCompleted);
        (_a = this.canvasFb) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this.canvasFbPdf) === null || _b === void 0 ? void 0 : _b.dispose();
        (_c = this.canvasFbCompleted) === null || _c === void 0 ? void 0 : _c.dispose();
        delete this.canvasFb;
        delete this.canvasFbPdf;
        delete this.canvasFbCompleted;
        this.canvasFb = null;
        this.canvasFbPdf = null;
        this.canvasFbCompleted = null;
    }
    getCanvasCssSize() {
        var _a;
        return (_a = this.canvasFbPdf) === null || _a === void 0 ? void 0 : _a.cssSize;
    }
}
//# sourceMappingURL=RenderWorkerBase.js.map